<main class="dialog-body">
    <div class="dialog-header">
        <div class="dialog-header-text">
            {{isEditMode ? "Edit teacher details" :"Add teacher details"}}
        </div>
        <div class="cros-icon" (click)="onCancel()" [class.disabled]="isProcessing">
            <img src="assets/images/cross-icon.svg" class="cross-icon" />
        </div>
    </div>

    <mat-dialog-content>
        <div class="dialog-content">
            <form [formGroup]="form" (ngSubmit)="onSubmit()" class="d-grid gap-14">
                <div class="form-group" *ngIf="!selectedSchoolID || isEditMode">
                    <app-input context="Normal" class="form-item" label="Select school" placeholder="Select school"
                        type="select" [control]="form.get('school')" [options]="schoolOptions" [showAddNew]="true"
                        [addNewText]="'Add new school'" (addNewClicked)="onAddNewSchool()" [required]="true"
                        [customErrorMessages]="customErrorMessages.school"
                        [disabled]="isEditMode ? false : !!selectedSchoolID">

                    </app-input>
                </div>

                <div class="grid-container">
                    <div class="form-group">
                        <app-input context="Normal" class="form-item" label="First name"
                            placeholder="Enter your first name" type="text" formControlName="firstName"
                            [required]="true" [control]="form.get('firstName')"
                            [customErrorMessages]="customErrorMessages.firstName">
                        </app-input>
                    </div>

                    <div class="form-group">
                        <app-input context="Normal" class="form-item" label="Last name" [required]="true"
                            placeholder="Enter your last name" type="text" formControlName="lastName"
                            [control]="form.get('lastName')" [customErrorMessages]="customErrorMessages.lastName">
                        </app-input>
                    </div>
                </div>

                <div class="grid-container">
                    <div class="form-group">
                        <app-input context="Normal" class="form-item" label="Email" placeholder="Enter your email"
                            type="email" formControlName="email" [control]="form.get('email')" [required]="true"
                            [customErrorMessages]="customErrorMessages.email">
                        </app-input>
                    </div>

                    <div class="form-group">
                        <app-input context="Normal" class="form-item" label="Phone number"
                            placeholder="Enter your phone number" type="text" formControlName="phoneNumber"
                            [control]="form.get('phoneNumber')" [customErrorMessages]="customErrorMessages.phoneNumber">
                        </app-input>
                    </div>
                </div>
            </form>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="action-buttons">
        <button class="cancel-button" (click)="onCancel()" [class.disabled]="isProcessing">Cancel</button>
        <button class="update-button" (click)="onSubmit()" [class.disabled]="isProcessing">
            <span *ngIf="!isProcessing">{{ isEditMode? "Update" :"Submit"}}</span>
            <span *ngIf="isProcessing" class="submit-loading">
                <span class="spinner"></span>
                Submiting...
            </span>
        </button>
    </mat-dialog-actions>
</main>